import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { CataloguePage, type NavigateSearch } from '../../catalogue/CataloguePage.js';
import { parseCatalogueSearch } from '../../catalogue/model/view.js';

export const Route = createFileRoute('/catalogue/$typeKey')({
  validateSearch: parseCatalogueSearch,
  component: CatalogueRoute,
});

function CatalogueRoute(): React.JSX.Element {
  const { typeKey } = Route.useParams();
  const search = Route.useSearch();
  const { me } = Route.useRouteContext();
  const go = Route.useNavigate();
  const navigate = useCallback<NavigateSearch>(
    (next, options) => {
      void go({ search: next, replace: options.replace });
    },
    [go],
  );
  return <CataloguePage typeKey={typeKey} me={me} search={search} navigate={navigate} />;
}
